export const isAllowedRange = (min: number, max: number) => (values: { floatValue?: number }) => {
    const { floatValue } = values;
    return floatValue === undefined || (floatValue >= min && floatValue <= max);
};
